// @flow
import React from 'react';
import Autosuggest from 'react-autosuggest';
import AbstractField from "./AbstractField";
import {Button} from 'reactstrap'
import Icon from "./../icon/FAIcon"
import {mergeAddons} from "./../utils"
import "./SuggestField.less"

const SUGGEST_THEME = {
    container: 'react-autosuggest__container',
    containerOpen: 'react-autosuggest__container--open',
    input: 'form-control react-autosuggest__input',
    suggestionsContainer: 'react-autosuggest__suggestions-container',
    suggestion: 'react-autosuggest__suggestion',
    suggestionFocused: 'react-autosuggest__suggestion--focused',
    sectionContainer: 'react-autosuggest__section-container',
    sectionTitle: 'react-autosuggest__section-title',
    sectionSuggestionsContainer: 'react-autosuggest__section-suggestions-container'
};

/**
 * Simple suggest field.
 *
 * Klasický autocomplete - napovídá hodnoty, uživatel může vybrat hodnotu nebo ji ručně napsat - i jinou, než je v seznamu.
 */
class SimpleSuggestField extends AbstractField {

    static PropTypes = {
        renderSuggestion: React.PropTypes.func,
        filterSuggestions: React.PropTypes.func,
        getItemValue: React.PropTypes.func,
        items: React.PropTypes.array.isRequired,
        dropdown: React.PropTypes.bool,
    };

    static defaultProps = {
        dropdown: false,
        renderSuggestion: i => <div>{i}</div>,
        filterSuggestions: (value, list) => {
            if (value === null || value.length === 0) {
                return list;
            }
            const inputValue = value.trim().toLowerCase();
            const inputLength = inputValue.length;

            return inputLength === 0 ? [] : list.filter(item =>
                    // item.toLowerCase().slice(0, inputLength) === inputValue
                    item.toLowerCase().indexOf(inputValue) !== -1
                );
        },
        getItemValue: i => i,
    };

    constructor(props) {
        super(props);

        this.componentIsUnmounting = false;

        this.state = {
            suggestions: props.filterSuggestions(null, props.items)
        }
    }

    componentWillUnmount() {
        this.componentIsUnmounting = true;
    }


    handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.stopPropagation();
            event.preventDefault();
        }
    };

    handleSuggestionsUpdateRequested = ({value}) => {
        const {filterSuggestions, items} = this.props;
        this.setState({suggestions: filterSuggestions(value, items)});
    };

    shouldRenderSuggestions = () => {
        return true;
    };

    handleClear = () => {
        const {onChange} = this.props;
        onChange(null);
    };

    handleDropdown = (e) => {
        if (!this.componentIsUnmounting) {
            e.stopPropagation();
            e.preventDefault();
            console.warn('handleDropdown')
            this.refs.autosuggest.input.focus();
        }
    };

    render() {
        const {renderSuggestion, filterSuggestions, getItemValue, value, className, addonsBefore, addonsAfter, onChange, onFocus, onBlur, items, dropdown, placeholder, removable, ...otherProps} = this.props;
        const shouldRenderSuggestions = dropdown ? this.shouldRenderSuggestions : undefined;

        const field = <div className={`autosuggest-container ${className}`}>
            <Autosuggest
                ref="autosuggest"
                theme={SUGGEST_THEME}
                getSuggestionValue={getItemValue}
                renderSuggestion={renderSuggestion}
                shouldRenderSuggestions={shouldRenderSuggestions}
                suggestions={this.state.suggestions}
                onSuggestionsFetchRequested={this.handleSuggestionsUpdateRequested}
                inputProps={{
                    value,
                    placeholder,
                    onChange: (e, {newValue, method}) => onChange(newValue),
                    onBlur: onBlur,
                    onFocus: onFocus,
                    onKeyDown: this.handleKeyDown
                }}
            />
        </div>;

        let hasAddonInline = false;
        const editAddons = [];
        let inlineAddon;
        if (dropdown) {
            if (value) {
                hasAddonInline = true;
                inlineAddon = <div className="input-group-btn input-addon-inline"><Button type="button" tabIndex={-1} ref="dropdownButton" onMouseDown={this.handleClear}><Icon fixedWidth icon='remove' /></Button></div>;
            } else {
                hasAddonInline = true;
                inlineAddon = <div className="input-group-btn input-addon-inline"><Button type="button" tabIndex={-1} ref="dropdownButton" onMouseDown={this.handleDropdown}><Icon fixedWidth icon='caret-down'/></Button></div>;
            }
        } else if (removable) {
            if (value) {
                hasAddonInline = true;
                inlineAddon = <div className="input-group-btn input-addon-inline"><Button type="button" tabIndex={-1} ref="dropdownButton" onMouseDown={this.handleClear}><Icon fixedWidth icon='remove'/></Button></div>;
            }
        }

        const fieldWrapper = <div className={`autosuggest-dropdown-field ${hasAddonInline ? "has-addon-inline" : ""}`}>
            {field}
            {inlineAddon}
        </div>;

        return this.renderFieldWithAddons(fieldWrapper, addonsBefore, mergeAddons(addonsAfter, editAddons));

    }
}

export default SimpleSuggestField;
